import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './routes';

// Static-site generation: vite-react-ssg pre-renders every route (incl. each
// directory category and listing) to real HTML for SEO, then hydrates.
export const createRoot = ViteReactSSG({ routes });
